import useHasPlusFeature from 'app/hooks/useHasPlusFeature';
import useLoggedInUser from 'app/hooks/useLoggedInUser';
import { useModalDismissedState } from 'app/shared-components/modals';
import type { IntroPopUp } from 'app/shared-components/modals/types';
import { WEB_BUILDER_PROMO_DISMISSED_KEY } from 'app/utils/seenStorageKeys';

/**
 * Dismissal is remembered per user so that on a shared browser (pharmacy PCs, support switching
 * accounts) one person's "Not now" doesn't hide the introduction from everyone else.
 */
export function webBuilderPromoDismissedKey(userId: string): string {
  return `${WEB_BUILDER_PROMO_DISMISSED_KEY}-${userId}`;
}

/**
 * Introduces the Website builder once to every logged-in user whose plan doesn't include it, the
 * first time they open Connect.
 */
export default function useWebBuilderPromoPopUp(): IntroPopUp {
  const user = useLoggedInUser();
  const {
    hasAccess: hasWebBuilder,
    isHidden: webBuilderHidden,
    isLoading: webBuilderLoading,
  } = useHasPlusFeature('webBuilderAccessEnabled', false);
  const { showOnboarding, dismiss } = useModalDismissedState(
    webBuilderPromoDismissedKey(user?._id ?? 'guest')
  );

  if (!user || !showOnboarding) return { status: 'hidden' };
  if (webBuilderLoading) return { status: 'loading' };
  // Unlike the gates, a plan that cannot be loaded still sees the promo, as before.
  if (hasWebBuilder || webBuilderHidden) return { status: 'hidden' };

  return { status: 'show', dismiss };
}
